import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import ScoresPage from './scoresPage';

const Baseball = (props) => {

    const { allSports } = props;
    const [leagueList, setLeagueList] = useState([]);


    useEffect(() => {
        const groups = allSports.filter(sport => sport.group === "Baseball" && sport.active)
        setLeagueList(groups)
    }, [allSports])

    return (
        <div className='sport-page'>
            <Router>
                <div className='leagues-list'>
                    {leagueList.map(league =>
                        <Link to={`/Baseball/${league.key}`} key={league.key} >{league.title}</Link>
                    )}
                </div>
                <Route path='/Baseball/:leagueKey' >
                    <ScoresPage />
                </Route>
            </Router>
        </div>
    )

}


export default Baseball;